import { Pipe, PipeTransform } from '@angular/core'; 
 
@Pipe({
    name:'tito'
})
export class titoPipe implements PipeTransform {
    transform(value:any, pmodel:any): any{  
        return value.filter(function(v,i){
        if((v.function_group && v.Main_Function_Code==pmodel.parent_id)
            ||(!v.function_group && v.Main_Function_Code==pmodel.parent_id) 
          ){ return v; }
    })
}
}